import { render, staticRenderFns } from "./VolunteerFamilyRecord.vue?vue&type=template&id=1f570066&scoped=true&"
import script from "./VolunteerFamilyRecord.vue?vue&type=script&lang=js&"
export * from "./VolunteerFamilyRecord.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerFamilyRecord.vue?vue&type=style&index=0&id=1f570066&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f570066",
  null
  
)

export default component.exports